import { render, staticRenderFns } from "./KidPractice.vue?vue&type=template&id=b7d6130a&scoped=true"
import script from "./KidPractice.vue?vue&type=script&lang=js"
export * from "./KidPractice.vue?vue&type=script&lang=js"
import style0 from "./KidPractice.vue?vue&type=style&index=0&id=b7d6130a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d6130a",
  null
  
)

export default component.exports